import * as styles from "./MonthPickerValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useMonthPickerContext } from "./MonthPicker.context";
import type { MonthPickerValueProps } from "./MonthPicker.types";

export function MonthPickerValue({
  placeholder = "--/----",
  className,
}: MonthPickerValueProps): JSX.Element {
  const { selected, locale } = useMonthPickerContext();

  const formatted =
    selected &&
    new Intl.DateTimeFormat(locale, { month: "long", year: "numeric" }).format(
      new Date(selected.year, selected.month, 1),
    );

  return (
    <span
      data-slot="month-picker-value"
      className={clsx(
        styles.value,
        !formatted && styles.placeholder,
        className,
      )}
    >
      {formatted || placeholder}
    </span>
  );
}
